import React, {useState, useEffect, useContext} from 'react';

import ModalWrapper from './ModalWrapper';
import LockerEventIssue from  '@/components/elements/LockerManagement/LockerEventIssue';

import { IHttpRequest, IHttpResponse } from  '@/interfaces/IHttp';
import { container, TYPES } from "@/inversifyconfig/container.config";

import { LockerManagementContext } from '@/context/LockerManagmentContext';
import { LockerContextRefreshType as refreshType, ErrorDetails, Errors } from  '@/interfaces/LockerManagement'
import { Truncate } from  '@/helpers/Text';

const ResolveIssuesModal = ({onClose, showModal, className, title, id, onConfirm}) => {
    const [resolveAllEnabled, setResolveAllEnabled] = useState<boolean>(false);
    const [errors, setErrors] = useState<Errors | undefined>();
    const [resolvedErrors, setResolvedErrors] = useState<number[]>([]);
    const [ isLoading, setIsLoading] = useState<boolean>(false);

   const httpCall = container.get<IHttpRequest>(TYPES.IHttpRequest);  
   const { refreshData } = useContext(LockerManagementContext)

   useEffect(()=>{
       setIsLoading(true);
       httpCall.get(`locker/batches/${id}/errors`)
        .then(({data}:IHttpResponse) => setErrors(data))
        .finally(() => setIsLoading(false));
    },[]);

    useEffect(()=>{
        return () => {
            setResolvedErrors([]);
        }
    },[])

    function getTotalErrors() {
        if (errors && errors.lockerBatchErrorsDetailsRecord) {
            return errors.lockerBatchErrorsDetailsRecord.reduce((acc, err) => acc + err.issueCount, 0)
        }
        return 0;
    };

    function resolveError(id: number, errorType: number) {
        httpCall.put(`locker/batches/${id}/errors/resolve/${errorType}`, {})
            .then(() => {
                setResolvedErrors([...resolvedErrors, errorType])
            })
            .catch(() => onConfirm('warning', 'Could not resolve this error at this time, please check the issue again'))
            .finally(() => refreshData(refreshType.EVENTS));
    }

    function ShowIssues(): JSX.Element {
        if (getTotalErrors() === 0) {
            return (
                <div className="issue-wrapper">
                    <div className="issue-titles">
                        <h4 className="success">No Issues</h4>
                    </div>
                </div>
            )
        }
        return (
            <>{errors.lockerBatchErrorsDetailsRecord.map((errorDetails: ErrorDetails, idx: number) => (
                    <LockerEventIssue 
                        key={idx}
                        id={idx}
                        issue={errorDetails}
                        resolveError={resolveError}
                        isResolved={resolvedErrors.includes(errorDetails.lockerIntentFileDeliveryRequestDetailedStatus)}
                        fileName={title.replace('More Details: ')}
                    />
                        
                ))}
            </>
        )
    }

    function resolveAllIssues () {
        httpCall.put(`locker/batches/${errors.batchId}/errors/resolve/all`, {})
            .then(() => onConfirm('success', <>You have successfully resolved <span className="emphasised-text">&nbsp;{errors.lockerBatchErrorsDetailsRecord.length}&nbsp;Failures</span></>))
            .catch(() => onConfirm('warning', 'Could not resolve all failures at this time, please check the issues again'))
            .finally(() => refreshData(refreshType.EVENTS))
        onClose();
    }

    return (
        <ModalWrapper 
            className={`standard-mini-modal${className ? ' ' + className : ''}`}
            isOpen={showModal}
            escClose={false}
            onRequestClose={onClose}
        >
            <div className="standard-mini-modal-wrapper">
                <h3 className="standard-mini-modal-title">{Truncate(title, 50)}</h3>
                <div className="resolve-issues-modal-content narrow-scroll-bar">
                 {!isLoading && <ShowIssues />}
                </div>
                <div className="resolve-issues-controls-wrapper">
                    <div className="custom-checkbox-wrapper">
                        {!!getTotalErrors()  &&
                        <>
                            <input
                                id="allow-resolve-all"
                                type="checkbox"
                                value="allow resolve all"
                                checked={resolveAllEnabled}
                                onChange={()=>setResolveAllEnabled(!resolveAllEnabled)}
                            />
                            <label htmlFor="allow-resolve-all">
                                Click to allow <span className="emphasis">'Resolve all'</span> options
                            </label>
                        
                        </>}
                    </div>
                    <div className="resolve-issues-button-wrapper">
                        {!!getTotalErrors()  && 
                        <button className="btn-blue" disabled={!resolveAllEnabled } onClick={resolveAllIssues}>
                            Resolve All
                        </button> }
                        <button className="btn-clear" onClick={onClose}>
                            Cancel
                        </button>
                    </div>
                </div>
            
            </div>
            
        
            
        </ModalWrapper>
)}

export default ResolveIssuesModal;